import React from 'react';
import {View} from 'react-native';
import {Props} from './model';
import {Modal} from '../../../../shared/components/modal/modal';
import {useStyles} from '../../../../shared/hooks/styles';
import {images} from '../../../../assets/icons';
import {useTheme} from '../../../../shared/theme';
import {SurveyCongratsMessage} from '../surveyCongratsMessage';

export default ({onClose}: Props) => {
  const theme = useTheme();
  const styles = useStyles(() => ({
    modalWrap: {
      paddingVertical: 0,
      paddingHorizontal: 0,
    },
    modalTitle: {display: 'none'},
    contentWrapper: {
      paddingHorizontal: 135,
      paddingTop: 80,
      paddingBottom: 127,
    },
    modalContent: {
      paddingTop: 0,
    },
    image: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      color: theme.polls.shapes.color,
    },
  }));
  return (
    <Modal
      contentStyle={styles.modalContent}
      wrapStyle={styles.modalWrap}
      titleStyle={styles.modalTitle}
      onClose={onClose}>
      <View style={styles.contentWrapper}>
        <View style={styles.image}>
          <images.SurveySuccessBg width={578} height={209} color={theme.polls.shapes.color} />
        </View>
        <SurveyCongratsMessage />
      </View>
    </Modal>
  );
};
